var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.967,
    height: 150.967,
    viewBox: "0 0 150.967 150.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.184,
    y1: 2.495,
    x2: 0.86,
    y2: 2.23,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#f7a63b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f3d792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#bde1e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ac2cb"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M229.7,302.706a5.912,5.912,0,0,1,5.9-5.9h44.827a5.912,5.912,0,0,1,5.9,5.9v13.853a53.928,53.928,0,0,1,11.788-10.8V302.69A17.709,17.709,0,0,0,280.427,285H235.6a17.709,17.709,0,0,0-17.69,17.69V418.277a17.709,17.709,0,0,0,17.69,17.69h44.827a17.709,17.709,0,0,0,17.69-17.69v-17.69h-68.4v-97.9Zm56.615,109.685v5.9a5.912,5.912,0,0,1-5.9,5.9H235.584a5.912,5.912,0,0,1-5.9-5.9v-5.9H286.3ZM333.5,332.184H321.709v11.788H309.921V355.76h11.788v11.788H333.5V355.76h11.788V343.972H333.5Zm-5.9-23.592a41.309,41.309,0,0,0-37.136,59.346,11.269,11.269,0,0,1-2.146,12.877l-10.341,10.341h49.623a41.282,41.282,0,0,0,0-82.565Zm0,70.777H302.458a22.994,22.994,0,0,0-1.4-16.585,29.163,29.163,0,0,1-2.959-12.894,29.494,29.494,0,1,1,29.494,29.494h0Z",
    transform: "translate(-217.91 -285)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.d67b60f759f7df94d8a702dc2d2d255e.svg";
export { ForwardRef as ReactComponent };